import { Component } from 'vue-property-decorator';
import Vue from 'vue';
import BpcContactTable from '@contacts/components/tables/contact-table/contact-table.vue';

@Component({
  name: 'bpc-contacts',
  components: {
    'bpc-contact-table': BpcContactTable,
  },
})
export default class Contacts extends Vue {
  /* Lifecycle hooks */
  // created() { }
  // mounted() {}
  // updated () { }
  // destroyed () { }
}
